"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/common/v1/idempotency.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.Idempotency = void 0;
function createBaseIdempotency() {
    return { key: "", ttl: undefined };
}
exports.Idempotency = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            ttl: isSet(object.ttl) ? globalThis.String(object.ttl) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.ttl !== undefined) {
            obj.ttl = message.ttl;
        }
        return obj;
    },
    create: function (base) {
        return exports.Idempotency.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseIdempotency();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.ttl = (_b = object.ttl) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=idempotency.js.map